export type Snackbar = {
  id: number | string;
  title: string;
  isShown?: boolean;
  buttonText?: string;
  timer?: number;
  callback?: () => unknown;
};

export enum ToastType {
  Default = 'default',
  Error = 'error',
  Success = 'success',
}

export type Toast = {
  id: string | number;
  title: string;
  content?: string;
  toastType?: ToastType;
  isClosable?: boolean;
  timer?: number;
};
